
import DataTable, { SortOrder, TableColumn } from 'react-data-table-component';
import { classNames } from '../common/utils/utils';
import i18n from '../common/config/i18n';
import EmptyContent from './EmptyContent';
import LoadingContent from './LoadingContent';
import { ChevronUpDownIcon } from '@heroicons/react/24/outline';
import { PaginationConfig } from '../common/constants/pagination';

export interface DataTableProps<T> {
  columns: TableColumn<T>[];
  data?: T[];
  loading?: boolean;
  pagination?: boolean;
  sortServer?: boolean;
  paginationPerPage?: number;
  paginationTotalRows?: number;
  paginationDefaultPage?: number;
  onChangePage?: (page: number) => void;
  onChangeRowsPerPage?: (rowsPerPage: number) => void;
  onSort?: (selectedColumn: TableColumn<T>, sortDirection: SortOrder, sortedRows: T[]) => void;
  defaultSortFieldId?: string | number;
  defaultSortAsc?: boolean;
  onRowClicked?: (row: T, e: React.MouseEvent) => void;
  pointerOnHover?: boolean;
}

const DataTableComponent = <T extends object>({
  columns,
  data,
  loading,
  pagination,
  sortServer,
  paginationPerPage,
  paginationTotalRows,
  paginationDefaultPage,
  onSort,
  onChangePage,
  onChangeRowsPerPage,
  defaultSortFieldId,
  defaultSortAsc,
  onRowClicked,
  pointerOnHover,
}: DataTableProps<T>) => {
  return (
    <DataTable
      className={classNames(
        !loading && data?.length ? 'border-cool-gray-200' : '',
        `rdt_TableWrapper`,
      )}
      noHeader
      columns={columns}
      data={data || []}
      progressPending={loading}
      pagination={pagination}
      paginationServer={pagination}
      paginationComponentOptions={{
        rowsPerPageText: (i18n.t('pagination:rows_per_page') as string) || '',
        rangeSeparatorText: (i18n.t('pagination:range_separator_text') as string) || '',
      }}
      paginationDefaultPage={paginationDefaultPage}
      responsive
      dense={true}
      sortIcon={<ChevronUpDownIcon />}
      sortServer={sortServer}
      onSort={onSort}
      paginationTotalRows={paginationTotalRows}
      paginationPerPage={paginationPerPage}
      paginationRowsPerPageOptions={PaginationConfig.rowsPerPageOptions}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      noDataComponent={<EmptyContent description={i18n.t('general:empty_table')} />}
      progressComponent={<LoadingContent />}
      defaultSortFieldId={defaultSortFieldId}
      defaultSortAsc={defaultSortAsc}
      onRowClicked={onRowClicked}
      pointerOnHover={pointerOnHover}
    />
  );
};

export default DataTableComponent;
